import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ButtonBase from "@mui/material/ButtonBase";

import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import { Typography } from "@mui/material";

export default function ButtonOptionsDialog({ open, handleClose, handleOption }) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="option-dialog"
      fullWidth
      maxWidth="sm"
      sx={{ maxWidth: "sm", margin: "auto" }}
    >
      <DialogTitle>{t("create.newButton")}</DialogTitle>
      <DialogContent>
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={6}>
            <ButtonBase
              onClick={() => handleOption("surveyButton")}
              style={{ width: "100%" }}
            >
              <div
                style={{
                  width: "100%",
                  height: theme.spacing(20),
                  display: "flex",
                  flexWrap: "wrap",
                  gap: theme.spacing(1),
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgba(0,0,0,0.2)",
                  borderRadius: theme.shape.borderRadius,
                }}
              >
                <AssignmentOutlinedIcon />
                <Typography variant="body2">
                  {t("create.buttonWithSurvey")}
                </Typography>
              </div>
            </ButtonBase>
          </Grid>
          <Grid item xs={6}>
            <ButtonBase
              style={{ width: "100%" }}
              onClick={() => handleOption("counterButton")}
            >
              <div
                style={{
                  width: "100%",
                  height: theme.spacing(20),
                  display: "flex",
                  flexWrap: "wrap",
                  gap: theme.spacing(1),
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgba(0,0,0,0.2)",
                  borderRadius: theme.shape.borderRadius,
                }}
              >
                <AddBoxOutlinedIcon />
                <Typography variant="body2">
                  {t("create.counterButton")}
                </Typography>
              </div>
            </ButtonBase>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
}
